export default {
  newKeyword: {
    id: 'card_new_keyword',
    defaultMessage: 'new',
  },
  afterBuyback: {
    id: 'card_after_buyback',
    defaultMessage: 'after tradein',
  },
  dueToday: {
    id: 'product_card_price_due_today',
    defaultMessage: 'due today',
  },
} as const
